"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactPlacesAutocomplete = _interopRequireDefault(require("react-places-autocomplete"));

var _loadPlacesScript = _interopRequireDefault(require("@jobmatchme/profile-components/es/utils/loadPlacesScript"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var PlacesPlainInput = function PlacesPlainInput(_ref) {
  var location = _ref.location,
      handlePlacesChange = _ref.handlePlacesChange,
      handlePlacesSelect = _ref.handlePlacesSelect,
      handleOnFocus = _ref.handleOnFocus,
      _ref$inputText = _ref.inputText,
      inputText = _ref$inputText === void 0 ? '' : _ref$inputText;
  var googleMapApiLoaded = (0, _loadPlacesScript.default)();
  return googleMapApiLoaded && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    className: _styleModule.default.placesInput,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactPlacesAutocomplete.default, {
      name: "locations",
      value: location,
      onChange: handlePlacesChange,
      onSelect: handlePlacesSelect,
      debounce: 500,
      searchOptions: {
        componentRestrictions: {
          // Restrict search to the following countries
          country: ['de', 'pl', 'at', 'dk']
        },
        types: ['geocode']
      },
      children: function children(_ref2) {
        var getInputProps = _ref2.getInputProps,
            suggestions = _ref2.suggestions,
            getSuggestionItemProps = _ref2.getSuggestionItemProps,
            loading = _ref2.loading;
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", (0, _extends2.default)({
            id: "placesInput",
            onTouchStart: handleOnFocus
          }, getInputProps({
            placeholder: inputText,
            className: _styleModule.default.input
          }))), !loading && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
            className: _styleModule.default.list,
            children: suggestions.map(function (suggestion, index) {
              var style = suggestion.active ? {
                backgroundColor: _styleModule.default.light,
                cursor: 'pointer'
              } : {
                backgroundColor: _styleModule.default.light,
                cursor: 'pointer'
              };
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, (0, _extends2.default)({
                className: _styleModule.default.item
              }, getSuggestionItemProps(suggestion, {
                style: style
              }), {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  children: suggestion.description
                })
              }), "sug".concat(index));
            })
          })]
        });
      }
    })
  });
};

var _default = PlacesPlainInput;
exports.default = _default;